<div class="cell-view">
  <div class="inner-view source-code-view">{{ rowData[fieldName] }}</div>

  <div *ngIf="editable; else readonly" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="PythonCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit('python', !editable)"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="PythonCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
  <ng-template #readonly>
    <div class="edit-menu">
      <button
        pButton
        id="cancelRowSelection"
        data-cy="PythonCell_Button_edit"
        icon="pi pi-eye"
        (click)="onEdit('python', !editable)"
      ></button>
    </div>
  </ng-template>
</div>
